import React from 'react';

import { Box } from '@mui/material';

import { CustomInput } from './CustomInput';
import { SelectProfile } from './Select/CustomSelect';


export const InputSelect = ({ 
  label, 
  icon, 
  id, 
  children, 
  value, 
  setValue, 
  defaultValue, 
  isMobile, 
  renderValue 
}) => {
  /**
   * Accessibility infos: https://mui.com/material-ui/react-select/#accessibility
   */
  
  const styles = {
    select: {
      width: isMobile ? '100%' : '90%', 
      borderRadius: '0.5em', 
      display:'flex', 
      paddingX: '0.5em'
    },
    menuList: {
      display: 'flex',
      padding: '0.5em', 
      justifyContent: 'space-around', 
      backgroundColor: 'secondary.main',
    },
  };

  return (

    <CustomInput label={label} id={id} icon={icon}>
      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <SelectProfile
          id={id}
          labelId={id}
          sx={styles.select}
          value={value}
          defaultValue={defaultValue}
          onChange={setValue}
          variant='standard'
          renderValue={renderValue}
          MenuProps={{
            id: `${id}_options` ,
            sx: {
              '& .MuiMenu-paper': {
                left: isMobile ? '0.5em !important' : null
              }
            },
            elevation: 0,
            MenuListProps: {sx: styles.menuList},
          }}
        >                   
          {children}
        </SelectProfile>
      </Box>     
    </CustomInput>

  );
};
